
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { ThankYou } from "@/components/ui/thank-you";
import CompactRegistrationForm from "@/components/auth/register/CompactRegistrationForm";
import { useMessageConfig } from "@/components/thank-you/MessageConfig";
import { useThankYouPage } from "@/hooks/use-thank-you-page";
import { useNavigate } from "react-router-dom";

export default function ThankYouPage() {
  const { fromWaitlist, isUnauthenticated, user } = useThankYouPage();
  const config = useMessageConfig({ fromWaitlist, isUnauthenticated, user });
  const navigate = useNavigate();
  
  // If user is authenticated and needs no registration form, redirect to dashboard
  useEffect(() => {
    if (user && !config.showRegistrationForm) {
      const timer = setTimeout(() => {
        navigate('/dashboard');
      }, 2000); // Short delay to allow user to see success message
      
      return () => clearTimeout(timer);
    }
  }, [user, config.showRegistrationForm, navigate]);
  
  return (
    <>
      <Helmet>
        <title>Thank You | Grandpal</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <ThankYou
        title={config.title}
        message={config.message}
        ctaText={config.ctaText}
        ctaUrl={config.ctaUrl}
        secondaryCtaText={config.secondaryCtaText}
        secondaryCtaUrl={config.secondaryCtaUrl}
        pageTitle="Thank You for Your Submission | Grandpal"
        showForm={config.showRegistrationForm}
        form={config.showRegistrationForm ? <CompactRegistrationForm fromThankYou={true} /> : undefined}
      />
    </>
  );
}
